const DEFAULT_HELP_CENTER_BASE_PATH = '/servicedesk/customer';
const DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH = '/servicedesk/customer/test';
const PORTALS_SEGMENT = '/portals';

const stripTrailingSlashes = (path: string): string => path.replace(/\/+$/, '');

/**
 * Recognises the default Help Center, whose base path the backend reports
 * without the `/portals` segment. The suffixed form is accepted too because
 * older callers still pass the full portals route.
 */
export const isDefaultHelpCenterBasePath = (basePath: string): boolean => {
	const normalizedBasePath = stripTrailingSlashes(basePath);

	return [
		DEFAULT_HELP_CENTER_BASE_PATH,
		DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH,
		`${DEFAULT_HELP_CENTER_BASE_PATH}${PORTALS_SEGMENT}`,
		`${DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH}${PORTALS_SEGMENT}`,
	].includes(normalizedBasePath);
};

/**
 * Resolves the path a Help Center renders its home page at. The default Help
 * Center serves its home from `<basePath>/portals`, while a named Help Center
 * serves it from the base path itself.
 */
export const getHelpCenterHomePath = (basePath: string): string => {
	const normalizedBasePath = stripTrailingSlashes(basePath);

	if (!isDefaultHelpCenterBasePath(normalizedBasePath)) {
		return normalizedBasePath;
	}

	return normalizedBasePath.endsWith(PORTALS_SEGMENT)
		? normalizedBasePath
		: `${normalizedBasePath}${PORTALS_SEGMENT}`;
};
